import { useState } from "react"
import Link from "next/link"
import { createPortal } from "react-dom"
import Image from "components/Image"
import slugify from "utilities/slugify"
import Expand from "public/assets/expand.svg"
import usePortalModal from "utilities/usePortalModal"
import GalleryModal from "components/GalleryModal"
import { track } from "utilities/tracking"

function Gallery({ images, heading, subheading, openModal, setSelectedGallery }) {
  return (
    <div className="w-full basis-1/3 pb-7 lg:pr-9">
      <Link
        onClick={() => {
          track({ event: "gallery_opened", heading, subheading })
          setSelectedGallery({ images, heading })
          openModal(`${slugify(heading)}`)
        }}
        href={`#${slugify(heading)}`}
        className="relative block w-full transition-all duration-300 hover:opacity-50"
      >
        <Image
          src={images[0]?.filename}
          alt={images[0]?.alt}
          placeholder={images[0]?.blurDataURL ? "blur" : "empty"}
          blurDataURL={images[0]?.blurDataURL}
          width={380}
          height={200}
          className="max-h-52 w-full rounded-10 object-cover"
        />
        <Expand className="absolute bottom-2 right-2" />
      </Link>
      <div className="px-5 pt-4">
        <h3 className="text-center font-secondary text-l1 font-medium text-teal-dark lg:text-l2">{heading}</h3>
        <h4 className="text-center text-m1 font-medium lg:text-m2">{subheading}</h4>
      </div>
    </div>
  )
}

export default function ImageGallerySection({ blok }) {
  const [selectedGallery, setSelectedGallery] = useState({ images: [], heading: "" })

  const gallerySlugs = blok.galleries.reduce(
    (acc, curr) => ({ [slugify(curr.heading)]: { images: curr.images, heading: curr.heading }, ...acc }),
    {},
  )

  function updateImagesByHash(hash) {
    setSelectedGallery(gallerySlugs[hash])
  }

  const { ref, mounted, modalOpen, openModal, closeModal, focusRef } = usePortalModal(
    blok.galleries.map(({ heading }) => slugify(heading)),
    updateImagesByHash,
  )

  return (
    <>
      <section className="px-6 pb-10">
        <div className="mx-auto flex max-w-screen-xl flex-col flex-wrap justify-center lg:flex-row lg:gap-y-6">
          {blok.galleries.map((gallery) => (
            <Gallery {...gallery} setSelectedGallery={setSelectedGallery} openModal={openModal} key={gallery._uid} />
          ))}
        </div>
      </section>
      {mounted && modalOpen
        ? createPortal(
            <GalleryModal
              images={selectedGallery.images}
              setSelectedGallery={setSelectedGallery}
              closeModal={closeModal}
              focusRef={focusRef}
            />,
            ref.current,
          )
        : null}
    </>
  )
}
